module.exports = __webpack_public_path__ + "assets/img/products.b8f71f70.svg";